

































import Vue from 'vue';
import Component from 'vue-class-component';
import Nodes from './nodes.vue';
import '../styles/sidebar.scss';
import config from '@/services/api-config';

export interface IMenu {
  name: string;
  icon: string;
  route: string;
  caption: string;
  isVisable: boolean;
  children: Array<IMenu>
}

@Component({
  name: "sidebar",
  components: { 'nodes': Nodes },
  props: ['active']
})

export default class Sidebars extends Vue {
  private width = window.screen.width;
  active: boolean = this.width < 800 ? false : this.active;
  private searchQuery: any = '';

  options = {
    height: '100%',
    size: 5
  }


  menu: Array<IMenu> = [
    {
      isVisable: true, name: 'hr', icon: 'users', route: 'customers-list', caption: 'All Users',
      children: []
    },
    {
      isVisable: true, name: 'role', icon: 'slack', route: '#', caption: 'Roles',
      children: [
        { isVisable: true, name: 'RolePrevilages', icon: 'icon-layers', route: 'roleprevilages', caption: 'Privileges', children: [] },
        { isVisable: true, name: 'UserLog', icon: 'icon-layers', route: 'userLog', caption: 'UserLog', children: [] }
     
      ]
    }];

  created() {
  }

  hasChildrenVisible(item: IMenu) {
    var found: boolean = false;
    item.children.forEach(element => {
      if (element.isVisable == true) {
        found = true;
      }
    });
    return found;
  }

  toggleBack() {
    localStorage.removeItem(config.widget);
    window.location.reload();
  }

  toggleClass(itemName: string) {
    (this.$refs[itemName + 'c'] as any)[0].className = (this.$refs[itemName + 'c'] as any)[0].className.indexOf('active') > -1 ? '' : 'active';
    (this.$refs[itemName] as any)[0].style.display = (this.$refs[itemName] as any)[0].className.indexOf('active') > -1 ? 'none' : 'block';
    (this.$refs[itemName] as any)[0].className = (this.$refs[itemName] as any)[0].className.indexOf('active') > -1 ? '' : 'active';
  }
}
